<template>
  <div></div>
</template>

<script>
  import auth from 'utils/auth'
  import { mapMutations } from 'vuex'
  import { SET_AUTHORIZED } from 'vx/mutations'

  export default {
    data () {
      return {}
    },

    /**
     * When the component is created we clear tokens and set the authorized user to false.
     *
     * Then redirects to the login route.
     *
     * @return void
     */
    created () {
      auth.clearToken()

      this[SET_AUTHORIZED](false)

      this.$router.push({ name: 'auth.login' })
    },

    methods: {
      /**
       * Map the following mutations:
       *
       * SET_AUTHORIZED
       */
      ...mapMutations('user', [SET_AUTHORIZED])
    }
  }
</script>



// WEBPACK FOOTER //
// Logout.vue?70cf66da